/** Translation bundle for the public user module screens and controls. */
export const userTranslations = {
    CS: {
        user: {
            login: 'Přihlášení',
            username: 'Uživatelské jméno',
            password: 'Heslo',
            loginButton: 'Přihlásit',
            forgottenPassword: 'Zapomenuté jméno nebo heslo?',
            loadingUser: 'Načítání uživatele',
            logoutHeading: 'Odhlašování…',
            profile: 'Uživatelský profil',
            noPermissionMessage: 'Nemáte oprávnění pro zobrazení této stránky.',
            loginAsAnother: 'Přihlásit se za jiného uživatele',
            languageChange: 'Změna jazyka',
            deleteUserSettings: 'Smazání uživatelského nastavení',
            settingsReset: 'Nastavení bylo resetováno',
            saveUserSettings: 'Uložení uživatelského nastavení',
            userSettingsSaved: 'Nastavení bylo uloženo',
            logout: 'Odhlášení',
            unexpectedErrorWhileLogout: 'Nečekáná chyba při odhlášení.',
            unexpectedErrorWhileLegacyLogout: 'Nečekáná chyba při odhlášení z původní aplikace.',
            loadCurrentUser: 'Načtení aktuálního uživatele',
            loadSettingsList: 'Načtení seznamu nastavení',
        },
    },
    EN: {
        user: {
            login: 'Login',
            username: 'Username',
            password: 'Password',
            loginButton: 'Login',
            forgottenPassword: 'Forgotten username or password?',
            loadingUser: 'Loading user',
            logoutHeading: 'Logging out...',
            profile: 'User profile',
            noPermissionMessage: 'You do not have permission to view this page.',
            loginAsAnother: 'Login as a different user',
            languageChange: 'Language change',
            deleteUserSettings: 'Delete user settings',
            settingsReset: 'Settings have been reset',
            saveUserSettings: 'Save user settings',
            userSettingsSaved: 'Settings have been saved',
            logout: 'Logout',
            unexpectedErrorWhileLogout: 'Unexpected error occurred while logging out.',
            unexpectedErrorWhileLegacyLogout: 'Unexpected error occurred while logging out of the legacy app.',
            loadCurrentUser: 'Load current user',
            loadSettingsList: 'Load settings list',
        },
    },
};
